import React from 'react';
import { makeStyles } from '@material-ui/core';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolderOutlined';

const useStyles = makeStyles({
  emptyState: {
    textAlign: 'center',
    marginBottom: '1rem',
    padding: '2rem',
    paddingBottom: 0
  }
});

interface EmptyStateProps {
  title: string;
  description: string;
}

const EmptyState = ({ title, description }: EmptyStateProps) => {
  const classes = useStyles();

  return (
    <div className={classes.emptyState}>
      <CreateNewFolderIcon
        htmlColor="#6b7280"
        style={{ width: '36px', height: '36px' }}
      />
      <div style={{ fontWeight: 600 }}>{title}</div>
      <div style={{ color: '#6b7280' }}>{description}</div>
    </div>
  );
};

export default EmptyState;
